<template>
  <div class="page">
    <!-- 头部 -->
    <Header title="直接购买" rightText="编辑" :rightHandler="toEdit" v-if="!isEdit" />
    <Header title="直接购买" rightText="完成" :rightHandler="toEdit" v-if="isEdit" />
    <div class="order-item">
      <van-image class="order-item-img" :src="(filePrefix + itemInfo.itemImageUri)"></van-image>
      <div class="order-item-info">
        <p>礼品名称：{{itemInfo.itemName}}</p>
        <div class="order-item-sort colo333">
          <div class="order-item-name" v-for="subItemLink in itemInfo.subItemLinkList" :key="subItemLink.linkId">
            礼品：{{subItemLink.subItem.itemName}}</div>
          <div class="themecolor" v-if="itemInfo.mOQMultiple == undefined && itemInfo.mOQ != undefined">
            最小起订量：{{cartList.mOQ}}</div>
          <div class="themecolor" v-if="itemInfo.mOQMultiple != undefined && itemInfo.mOQ == undefined">
            最小起订倍数：{{cartList.mOQMultiple}}</div>
          <div class="themecolor" v-if="itemInfo.mOQMultiple != undefined && itemInfo.mOQ != undefined">
            最小起订倍数：{{cartList.mOQMultiple}}</div>
        </div>
        <div class="order-item-value">
          <p class="point-name"> {{itemInfo.firstPointTypeName}}：
            <span v-if="itemInfo.isPromotion === 0">{{itemInfo.exchangePoint}}</span>
            <span v-if="itemInfo.isPromotion === 1">{{itemInfo.promotionPoint}}</span>
          </p>
          <span v-if="!isEdit">×{{qtyModel.itemQuantity}}</span>
          <van-stepper v-if="isEdit" :value="qtyModel.itemQuantity" :disabled="isOnlineCourse || userRole === '03'"
            async-change @change="change" :max="itemQuantityMax" />
        </div>
      </div>
    </div>
    <div class="fixed">
      <div class="point"><span v-if="!isEdit">{{itemInfo.firstPointTypeName}}:{{integralObj.integralPoint}}</span>
      </div>
      <van-button type="primary" size="large" v-if="!isEdit" @click="settlementCheck" :disabled="userRole === '03'">去结算
      </van-button>
      <van-button type="primary" size="large" v-else :disabled="isOnlineCourse || userRole === '03'">去删除</van-button>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import sortApi from '@/api/sort'
import cartApi from '@/api/cart'
import { mapState } from 'vuex'
export default {
  components: {
    Header
  },
  data () {
    return {
      itemId: '',
      cartId: '',
      isEdit: false,
      imageList: [],
      itemInfo: {},
      cartList: [],
      qtyModel: {
        itemQuantity: 0
      },
      integralObj: {
        integralPoint: 0
      },
      couponId: '',
      itemQuantityMax: ''
    }
  },
  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl,
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    }),
    // 判断是否线上课程
    isOnlineCourse () {
      return (this.itemInfo && this.itemInfo.itemCategory && this.itemInfo.itemCategory.parentList &&
        this.itemInfo.itemCategory.parentList.length && this.itemInfo.itemCategory.parentList[0].categoryCode === '1032') || (this.itemInfo && this.itemInfo.itemCategory &&
          (this.itemInfo.itemCategory.categoryCode === '13003' || this.itemInfo.itemCategory.categoryCode === '501'))
    }

  },
  created () {
    if (this.userRole === '03') {
      this.$toast('没有下单权限')
    } else {
      this.init()
    }
  },
  methods: {
    init () {
      this.itemId = this.$route.query.itemId || ''
      this.couponId = this.$route.query.couponId || ''
      this.queryItemInfo()
      // this.getCartList()
    },
    queryItemInfo () {
      let params = {
        itemId: this.itemId || ''
      }
      sortApi.queryItemInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          const { imageList, itemInfo } = res.data.resultData
          this.imageList = imageList
          this.itemInfo = itemInfo
          this.getCartList()
        }
      })
    },
    getCartList () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      cartApi.getCartList().then(res => {
        if (res.data.resultCode === '0') {
          const { cartList } = res.data.resultData
          this.cartList = cartList
          const index = this.cartList.findIndex(item => {
            return item.itemId === this.itemId
          })
          if (index !== -1) {
            this.cartId = this.cartList[index].cartId
            if (this.isOnlineCourse) {
              this.qtyModel.itemQuantity = 1
              this.update(this.itemId, 1)
            } else {
              this.qtyModel.itemQuantity += this.cartList[index].itemQuantity
            }
          }
          if (this.itemInfo.isPromotion === 0) {
            this.integralObj.integralPoint = this.itemInfo.exchangePoint * this.qtyModel.itemQuantity
          } else {
            this.integralObj.integralPoint = this.itemInfo.promotionPoint * this.qtyModel.itemQuantity
          }
          let params = {
            itemId: this.itemId,
            couponId: this.couponId
          }
          cartApi.queryCartMax(params).then(res => {
            if (res.data.resultCode === '0') {
              this.itemQuantityMax = (res.data.resultData && res.data.resultData.itemQuantity) || 9999
            }
            this.$toast.clear()
          })
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 购物车修改礼品数量
    update (itemId, num) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      let data = {
        itemId: itemId,
        itemQuantity: num,
        cartId: this.cartId
      }
      cartApi.updateCar(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$toast.clear()
          this.integralObj.integralPoint = 0
          if (this.itemInfo.isPromotion === 0) {
            this.integralObj.integralPoint += this.itemInfo.exchangePoint * this.qtyModel.itemQuantity
          } else {
            this.integralObj.integralPoint += this.itemInfo.promotionPoint * this.qtyModel.itemQuantity
          }
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 编辑/完成按钮
    toEdit () {
      this.isEdit = !this.isEdit
    },
    // 购物车礼品选中状态更新及结算前校验
    settlementCheck () {
      if (this.itemInfo.usableStock === 0 && this.itemInfo.logicalStock === 0 && this.itemInfo.isPreOrder === 0) {
        this.$toast('已售完')
        return
      }
      let data = [{
        itemId: this.itemId,
        selected: 1,
        cartId: this.cartId
      }]
      cartApi.checkSettlement(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$router.push({
            name: 'orderCreate',
            params: {
              selectCouponId: this.couponId
            }
          })
        }
      })
    },
    change (value) {
      const old = this.qtyModel.itemQuantity
      if (value) {
        if (value > this.itemQuantityMax) {
          this.qtyModel.itemQuantity = this.itemQuantityMax
        } else {
          this.qtyModel.itemQuantity = value
        }
        if (old !== this.qtyModel.itemQuantity) {
          this.update(this.itemId, this.qtyModel.itemQuantity)
        }
      }
    }

  }
}
</script>
<style  scoped lang="less">
.order-item {
  padding: 0.3rem;
  display: flex;
  align-items: stretch;
  color: var(--base-green);
  font-size: 0.35rem;
  height: 100%;
  min-height: 1.8rem;

  .order-item-img {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 0.3rem;
  }

  .order-item-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1 0%;

    .order-item-sort {
      color: #333;
    }

    .order-item-value {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .point-name {
        color: #e20015;

        span {
          font-size: 0.4rem;
        }
      }
    }
  }
}

.fixed {
  height: 1.5rem;

  .point {
    text-align: center;
    color: #c36c4d;
    flex: 0 0 70%;
    background-color: #fff;
    line-height: 1.5rem;
  }

  button {
    height: 100%;
  }
}
</style>
